import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import ESPIntegrationsModal from "views/mobile/lightbox-builder/modals/ESPIntegrationsModal";
import ESPCurrentIntegration from "./ESPCurrentIntegration";
import SectionTitle from "./SectionTitle";

const useStyles = makeStyles({
  integration: {
    padding: 20,
  },
});

function ESPIntegration() {
  const css = useStyles();

  return (
    <section className={css.integration}>
      <SectionTitle />
      <ESPCurrentIntegration />
      <ESPIntegrationsModal />
    </section>
  );
}

export default React.memo(ESPIntegration);
